module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_j_normal.94d03e8c.png";